import { API, snakeify, type PimFields } from "@thenounproject/lingo-core";
import { createAsyncAction } from "@actions/actionCreators";
import { toApiFields } from "@features/products/productTypeFields";

type VariantSync = {
  uuid?: string;
  optionValues: { [optionName: string]: string };
  fields?: PimFields;
  marketUuid?: string | null;
  displayOrder?: number;
  status?: string;
};

type Args = {
  spaceId: number;
  id: string;
  fields?: PimFields;
  marketUuid?: string;
  status?: string;
  variants?: VariantSync[];
};

const [useUpdateProduct, updateProduct] = createAsyncAction(
  "products/update",
  async ({ spaceId, id, fields, marketUuid, status, variants }: Args) => {
    const res = await API.call<{ product: string }>({
      endpoint: `spaces/${spaceId}/products/${id}`,
      method: "PUT",
      data: {
        fields: fields ? snakeify(toApiFields(fields)) : undefined,
        market_uuid: marketUuid,
        status,
        variants: variants?.map(v => ({
          uuid: v.uuid,
          option_values: v.optionValues,
          fields: v.fields ? toApiFields(v.fields) : undefined,
          market_uuid: v.marketUuid,
          display_order: v.displayOrder,
          status: v.status,
        })),
      },
    });
    return { ...res, result: res.result.product };
  }
);

export default useUpdateProduct;
export { updateProduct };
